import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { CircularProgress } from "@material-ui/core";

const Loader = ({ message }) =>
    ReactDOM.createPortal(
        <div className='loading-spiner-call'>
            <div className="loading">
                {/* <span class="loader-animation"></span> */}
                <div style={{ padding: '200px', textAlign: 'center', color: 'var(--primary-color)' }}>
                    {message ? <p>{message}</p> : <CircularProgress />}
                </div>
            </div>
        </div>,
        document.body
    )

export default Loader;